const STORAGE_KEYS = {
	PLATFORM_OS: 'platform_os',
	CHECKOUT: 'checkout',
	COUPON: 'coupon',
	ONBOARDING_FAILED_DATE: 'onboarding-failed-date',
	LAST_CHAT_AI: 'last-chat-ai',
	ESCALATION_FORM: 'escalation-form',
	IS_SIDEBAR_EXPANDED: 'is-sidebar-expanded',
	NOTIFICATIONS_VIEWED: 'notifications-viewed',
};

export default STORAGE_KEYS;
